import createReactComponent from '../createReactComponent';
export default createReactComponent(
  'corner-up-right-double',
  'IconCornerUpRightDouble',
  [
    ['path', { d: 'M4 18v-6a3 3 0 0 1 3 -3h7', key: 'svg-0' }],
    ['path', { d: 'M10 13l4 -4l-4 -4m5 8l4 -4l-4 -4', key: 'svg-1' }],
  ],
);
